import CityPageTemplate from "../city-template/CityPageTemplate";
import { goffstownConfig } from "./data";

export default function GoffstownPage() {
  return <CityPageTemplate config={goffstownConfig} />;
}